import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Claiming = () => (
  <>
    <Card gap='$4'>
      <DocSection id='how-claiming-works' title='How Claiming Works'>
        <Paragraph size='$5'>
          When an Organizer creates a Presentation for an external speaker,
          they enter the speaker's name and email address. The speaker receives
          a claim invitation email with a link to take ownership of the
          Presentation.
        </Paragraph>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='link' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Claim link</Paragraph> — The speaker
              clicks the link in the invitation email to begin the claim process.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='person' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Sign in or sign up</Paragraph> — The
              speaker signs in to an existing Guild account or creates a new one.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='checkmark' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Claim ownership</Paragraph> — Once
              claimed, the Presentation appears on the speaker's profile and they gain
              full editing access to update the title, description, and video link.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='updating-presenter-email' title='Updating the Presenter Email'>
        <Paragraph size='$5'>
          If the Organizer updates the presenter email on an unclaimed
          Presentation, a new invitation is sent to the updated address. This
          is useful if the original email was entered incorrectly or the
          speaker prefers a different account.
        </Paragraph>
        <DocScreenshot
          src='docs/presentations/presentation-page.png'
          alt='Presentation page showing presenter attribution — once claimed, the Presentation appears on the speaker profile with full editing access'
          caption='A claimed Presentation appears on the speaker profile with full editing access'
        />
      </DocSection>
    </Card>
  </>
)

export default Claiming
